import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  Platform,
  Alert,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import {AppToast} from '../../HelperClasses/AppToast';
import Switch from "react-switch";
import {readAppCustomizationDraft, writeAppCustomizationDraft, clearAppCustomizationDraft} from '../../Localization/appCustomizationDrafts';

const AppConstants = require('../../Constants/AppConstants');

const APPURL = require('../../Constants/URLConstants');
let KeyGroup = 'payments';
let keys = ['enable_logs','enable_signup_first'];

export default class OtherSetting extends Component {
  t = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  constructor(props) {
    super(props);
    const draft = readAppCustomizationDraft('otherSettings');
    this.state = {
      statusValue: draft.statusValue ?? false,
      dataLoad: false,
      logSwitchValue: draft.logSwitchValue ?? false,
      signUpSwitchValue: draft.signUpSwitchValue ?? false,
    };
  }
  static propTypes = {
    backBtn: PropTypes.func,
  };
  componentDidMount() {
    this.loadConfigApi();
  }
  componentDidUpdate() {
    if (this.draftReady && !this.draftCleared) {
      writeAppCustomizationDraft('otherSettings', {
        statusValue: this.state.statusValue,
        logSwitchValue: this.state.logSwitchValue,
        signUpSwitchValue: this.state.signUpSwitchValue,
      });
    }
  }
  updateDraftField = (field, value) => {
    this.draftCleared = false;
    this.setState({[field]: value});
  };
  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(APPURL.URLPaths.config + `?key_group=${KeyGroup},general`,'get');
    console.log('responseJson ==> ', responseJson)
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      const draft = readAppCustomizationDraft('otherSettings');
      this.setState({
        logSwitchValue: draft.logSwitchValue ?? configs[keys[0]] ?? false,
        signUpSwitchValue: draft.signUpSwitchValue ?? configs[keys[1]] ?? false,
        statusValue: draft.statusValue ?? configs.show_pending_balance ?? false,
      });
    }
    this.draftReady = true;
    this.setState({dataLoad: true});
  };
  addOrUpdateChatApi = async () => {
    var configs = [];
    let values = [this.state.logSwitchValue,this.state.signUpSwitchValue];
    for (let k = 0; k < keys.length; k++ ) {
      let fDict = {
        key_group: 'general',
        key: keys[k],
        value: values[k],
        secured: false,
      };
      configs.push(fDict);
    }
    if (!AppConstants.appType) {
      let fDict = {
        key_group: KeyGroup,
        key: 'show_pending_balance',
        value: this.state.statusValue,
        secured: false,
      };
      configs.push(fDict);
    }
    const responseJson = await networkService.networkCall(APPURL.URLPaths.config, 'post',
      JSON.stringify({ configs: configs }));
    this.setState({ dataLoad: true });
    if (responseJson['status'] == true) {
      this.draftCleared = true;
      clearAppCustomizationDraft('otherSettings');
      this.alertView('uploaded');
    }
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      AppToast();
    } else {
      Alert.alert(title);
    }
  }
  //MARK:-  Buttons Action Method 
  saveBtnAction() {   
    this.setState({dataLoad: false});
    this.addOrUpdateChatApi();
  }
  //MARK:-  UI 
  renderHideBalance = () => {
    if (!AppConstants.appType) {
      return <View style={{ flexDirection: 'row', marginTop: 20 }}>
         <Switch
          onColor={colors.AppNewGreen}
          onChange={() => this.updateDraftField('statusValue', !this.state.statusValue)}
          checked={this.state.statusValue}
          height={22}
          width={50}
        />
        <Text style={appConfigStyle.statusTxtStyle}>{this.t('app_customization.other_hide_balances', 'Hide balances & payouts in more section')}</Text>
      </View>
    } else {
      return <View />
    }
  }
  render() {
    return (
      <View style={{width: '70%', marginBottom: 130, marginLeft: 10}}>
        <Text style={tableStyle.listTitleText}>{this.t('app_customization.other_settings', 'Other Settings')}</Text>
        <Text style={appConfigStyle.subTitleStyle}>
          {AppConstants.plainTextString}
        </Text>
        <View style={appConfigStyle.horizontalLineViewStyle} />
        <View style={appConfigStyle.subViewStyle}>
          <View style={{ flexDirection: 'column', flex: 1.5 }}>
            <View style={{ marginTop: -30 }}>
              <View style={{ flexDirection: 'row', marginTop: 20 }}>
                <Switch
                  onColor={colors.AppNewGreen}
                  onChange={() => this.updateDraftField('logSwitchValue', !this.state.logSwitchValue)}
                  checked={this.state.logSwitchValue}
                  height={22}
                  width={50}
                />
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <Text style={appConfigStyle.statusTxtStyle}>{this.t('app_customization.other_enable_logs', 'Enable logs')} </Text>
                </View>
              </View>
            </View>
            <View style={{ flexDirection: 'row', marginTop: 20 }}>
              <Switch
                  onColor={colors.AppNewGreen}
                  onChange={() => this.updateDraftField('signUpSwitchValue', !this.state.signUpSwitchValue)}
                  checked={this.state.signUpSwitchValue}
                  height={22}
                  width={50}
                />
              <Text style={appConfigStyle.statusTxtStyle}>{this.t('app_customization.other_signup_first', 'Get sign up first')}</Text>
            </View>
            {this.renderHideBalance()}
          </View>
        </View>
        <Appload enable={this.state.dataLoad} />
      </View>
    );
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'var(--color-surface)',
  },
});
